import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { StoryConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class StoryApiModule {
    public static forRoot(configurationFactory: () => StoryConfiguration): ModuleWithProviders<StoryApiModule> {
        return {
            ngModule: StoryApiModule,
            providers: [ { provide: StoryConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: StoryApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('StoryApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
